import bus from 'vue3-eventbus';

export const PHONE_REVERIFY_CODE = 'PHONE_REVERIFY_REQUIRED';
export const PHONE_VERIFY_PATH = '/account/phone-verify';
export const NOTICE_LIST_PATH = '/my/notice';
export const SMS_VERIFY_SKIP_KEY = 'qdpic_sms_phone_verified';

export const PHONE_VERIFY_ALLOW_PATHS = [
  PHONE_VERIFY_PATH,
  NOTICE_LIST_PATH,
];

let forceShowOverlay = false;

export function isPhoneReverifyError(error = {}) {
  const code = error?.code ?? error?.data?.code ?? null;
  return code === PHONE_REVERIFY_CODE || String(code) === PHONE_REVERIFY_CODE;
}

export function markSmsLoginVerified() {
  try {
    sessionStorage.setItem(SMS_VERIFY_SKIP_KEY, '1');
  } catch (e) {
    /* ignore */
  }
}

export function clearSmsLoginVerified() {
  try {
    sessionStorage.removeItem(SMS_VERIFY_SKIP_KEY);
  } catch (e) {
    /* ignore */
  }
}

export function wasSmsLoginVerified() {
  try {
    return sessionStorage.getItem(SMS_VERIFY_SKIP_KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function isBoundMobile(mobile) {
  if (mobile === 0 || mobile == null || mobile === false) return false;
  const trimmed = String(mobile).trim();
  if (!trimmed || trimmed === '-' || trimmed.toLowerCase() === 'null' || trimmed === 'undefined') {
    return false;
  }
  const compact = trimmed.replace(/\s/g, '');
  if (/^\*+$/.test(compact)) return false;
  return /\d/.test(compact);
}

export function maskMobile(mobile) {
  if (!mobile) return '';
  const text = String(mobile);
  if (text.includes('*')) return text;
  const digits = text.replace(/\D/g, '');
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}****${digits.slice(7)}`;
  }
  if (digits.length >= 7) {
    return `${digits.slice(0, 3)}****${digits.slice(-4)}`;
  }
  return text;
}

/** 顶栏/个人中心展示名：手机号脱敏，昵称原样。 */
export function formatDisplayName(username, mobile = '', fallback = '') {
  const name = username && String(username) !== 'undefined' ? String(username).trim() : '';
  if (name) {
    const digits = name.replace(/\D/g, '');
    if (digits.length === 11 && /^1\d{10}$/.test(digits)) {
      return maskMobile(name);
    }
    return name;
  }
  if (mobile) return maskMobile(mobile);
  return fallback || '';
}

function isTruthyFlag(value) {
  return value === true || value === 1 || value === '1' || value === 'true';
}

export function parsePhoneVerifyState(me = {}) {
  const required = isTruthyFlag(
    me.phone_verify_required ??
    me.phoneVerifyRequired ??
    me.need_phone_verify
  );
  const deadline = me.phone_verify_deadline || me.phoneVerifyDeadline || '';
  const noticeAt = me.phone_verify_notice_at || me.phoneVerifyNoticeAt || '';
  const mobile = me.mobile || '';
  return {
    required,
    deadline,
    noticeAt,
    mobile,
    maskedMobile: maskMobile(mobile),
    hasMobile: isBoundMobile(mobile),
  };
}

export function isPhoneVerifyAllowPath(path = '') {
  return PHONE_VERIFY_ALLOW_PATHS.some(
    (allow) => path === allow || path.startsWith(`${allow}/`)
  );
}

export function shouldShowPhoneVerifyOverlay(me, path = '') {
  if (isPhoneVerifyAllowPath(path)) {
    return false;
  }
  if (forceShowOverlay) {
    return true;
  }
  const state = parsePhoneVerifyState(me || {});
  if (wasSmsLoginVerified()) {
    if (!state.required) {
      clearSmsLoginVerified();
    }
    return false;
  }
  return state.required;
}

export function showPhoneVerifyOverlay() {
  forceShowOverlay = true;
  bus.emit('showPhoneVerifyOverlay', true);
}

export function hidePhoneVerifyOverlay() {
  forceShowOverlay = false;
  bus.emit('showPhoneVerifyOverlay', false);
}

export function isPhoneVerifyOverlayForced() {
  return forceShowOverlay;
}

export function resolveNoticeLink(notice = {}) {
  if (notice.type === 'phone_reverify') {
    return notice.link || PHONE_VERIFY_PATH;
  }
  if (notice.link) {
    return notice.link;
  }
  return '';
}

export function normalizeNotice(item = {}) {
  return {
    id: item.id,
    title: item.title || item.subject || item.name || '',
    content: item.content || item.body || item.message || item.detail || '',
    type: item.type || '',
    link: item.link || item.url || '',
    created_at:
      item.created_at ||
      item.createdAt ||
      item.time ||
      item.updated_at ||
      item.send_at ||
      '',
  };
}

export function normalizeNoticeList(res) {
  if (!res) {
    return {
      list: [],
      pagination: { total: 0, current: 1, pageSize: 10 },
    };
  }
  if (Array.isArray(res)) {
    return {
      list: res.map(normalizeNotice),
      pagination: { total: res.length, current: 1, pageSize: res.length || 10 },
    };
  }
  const nested =
    res.data &&
    !Array.isArray(res.data) &&
    (res.data.list || res.data.data || res.data.items)
      ? res.data
      : res;
  const list = nested.data || nested.list || nested.items || nested.notices || [];
  const pagination = nested.pagination || {
    total: nested.total ?? list.length,
    current: nested.current ?? nested.page ?? 1,
    pageSize: nested.pageSize ?? nested.page_size ?? 10,
  };
  return {
    list: (Array.isArray(list) ? list : []).map(normalizeNotice),
    pagination,
  };
}
